/**
 * Jarvis Dashboards Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 * Includes the main /dashboards path + external dashboard routes
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const JarvisDashboard = lazy(() =>
  import('@src/apps/JarvisDashboard/JarvisDashboard').then(m => ({ default: m.JarvisDashboard }))
);

const ReactExdashboards = lazy(() =>
  import('@web/apps/ReactExdashboards/ReactExdashboards').then(m => ({ default: m.ReactExdashboards }))
);

export const jarvisdashboardsRoutes: RouteConfig[] = [
    {
    path: 'operations',
    component: JarvisDashboard,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Operations',
      breadcrumb: 'Operations',
    },
  },
  // External dashboards (mirrors legacy app reactExdashboardsRoutes)
  {
    path: 'segmentationbuilder',
    component: ReactExdashboards,
    guards: ['auth', 'vendor'],
    data: { title: 'Segmentation Builder', breadcrumb: 'Segmentation Builder' },
  },
  {
    path: 'mysavedreports',
    component: ReactExdashboards,
    guards: ['auth', 'vendor'],
    data: { title: 'My Saved Reports', breadcrumb: 'My Saved Reports' },
  },
  {
    path: 'providerportaldashboard',
    component: ReactExdashboards,
    guards: ['auth', 'vendor'],
    data: { title: 'Provider Portal Dashboard', breadcrumb: 'Provider Portal Dashboard' },
  },
  {
    path: 'claimsapiprovider',
    component: ReactExdashboards,
    guards: ['auth', 'vendor'],
    data: { title: 'Claims API Provider', breadcrumb: 'Claims API Provider' },
  },
  {
    path: 'userlookuptool',
    component: ReactExdashboards,
    guards: ['auth', 'vendor'],
    data: { title: 'User Lookup Tool', breadcrumb: 'User Lookup Tool' },
  },
];

